import { MarketplaceTemplateEnrichedWithCreatorName } from '../domain/entities/marketplaceTemplate';
import { useInitialState } from '../contexts/InitialStateContext';
import { useSelectedCategory } from './useSelectedCategory';
import { CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS } from '../config';

export const useMarketplaceTemplates =
  (): MarketplaceTemplateEnrichedWithCreatorName[] => {
    const { marketplaceTemplatesByTemplateId } = useInitialState();
    const { slug } = useSelectedCategory() ?? {};

    if (
      !slug ||
      !Object.keys(CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS).includes(slug)
    ) {
      return [];
    }

    return CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS[slug]
      .map((templatedId) => marketplaceTemplatesByTemplateId[templatedId])
      .filter(Boolean);
  };
// {
//   id: '75130308-6192-4f57-9d7f-7a40d5c922c2',
//   thumbnailUrl:
//     'https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/templates/75130308-6192-4f57-9d7f-7a40d5c922c2/long-thumbnail/1721900726200/Smart%20home%20cover.webp',
//   title: 'Smart Home',
//   creatorName: 'Evoke Digital',
//   price: '73 €',
// },
// {
//   id: '9e7d1658-169b-4b04-88b3-992103537ad2',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_76e758f6483d428c8f33e7a6159a5006~mv2.png',
//   title: 'Coffee Brand Ecommerce',
//   creatorName: 'Evoke Digital',
//   price: '69 €',
// },
// {
//   id: '309c24df-119c-4b31-ac83-dcbd8211a399',
//   thumbnailUrl:
//     'https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/templates/309c24df-119c-4b31-ac83-dcbd8211a399/long-thumbnail/1721900929509/East-Parlour%20cover.webp',
//   title: 'East-Parlour | Hair Salon',
//   creatorName: 'Sha Hilson',
//   price: '38 €',
// },
// {
//   id: 'a2403d64-4d75-42c9-860d-88e87d92133c',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_453304fd6cb94a14bbeec6f7a9d8b7ca~mv2.png',
//   title: 'Oranzo',
//   creatorName: 'ThemetechMount',
//   price: '48 €',
// },
// {
//   id: '1e38513b-39fd-424e-97b2-6671642b70dd',
//   thumbnailUrl:
//     'https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/templates/a2403d64-4d75-42c9-860d-88e87d92133c/long-thumbnail/1721904709328/Sophia%20bennet%20-%20cover.webp',
//   title: 'Sophia Bennett',
//   creatorName: 'Cultelier',
//   price: '284 €',
// },
// {
//   id: '0930b1f4-b578-4f3d-892f-fb7443fa719c',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_ba80248e902f4520b8a426020610d514~mv2.png',
//   title: 'Digital Agency',
//   creatorName: 'Studio II',
//   price: 'Free',
// },
// {
//   id: '62e2b35d-81e6-47e9-a81c-d84ee0c1db55',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_ba80248e902f4520b8a426020610d514~mv2.png',
//   title: 'Luxury',
//   creatorName: 'Pickles Graphic',
//   price: '97 €',
// },
// {
//   id: 'f9e7b4e1-4f6e-4b5b-8a8f-0f9a6b8d0c4a',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_d2180607bcf84f179671443a321d1b7d~mv2.png',
//   title: 'Masonry Layout',
//   creatorName: 'Studio II',
//   price: 'Free',
// },
// {
//   id: 'p9e7b4e1-4f6e-4b5b-8a8f-0f9a6b8d0c4a',
//   thumbnailUrl:
//     'https://static.wixstatic.com/media/90ef97_cba2687504174ea1bfbf1d5972e3c525~mv2.png',
//   title: 'GoHike',
//   creatorName: 'Certified Code',
//   price: '10 €',
// },
// {
//   id: 'l9e7b4e1-4f6e-4b5b-8a8f-0f9a6b8d0c4a',
//   thumbnailUrl:
//     'https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/templates/1e38513b-39fd-424e-97b2-6671642b70dd/long-thumbnail/1721913773152/Simple%20Profile%20-%20cover.png',
//   title: 'Simple Profile',
//   creatorName: 'rino design works',
//   price: '66 €',
// },
